import React, { useMemo, useState, useEffect, useContext, useCallback } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import DataTable from "../../../components/common/DataTable";
import { READ_CUSTOMER_LEDGER, } from "../../../services/apiRoutes";
import { AuthContext } from "../../../context/AuthContext";
import CustomLoader from "../../common/CustomLoader";
import CustomReport from "../../common/CustomReport";
import { genericPost } from "../../../services/authServices";
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import CustomDataTable from "../../common/CustomDataTable";
import CustomFilter from "../../common/CustomFilter";
import { Box, Grid } from "@mui/material";
import CustomTextField from "../../common/CustomTextField";
import CustomButton from "../../common/CustomButton";



const title = "Customer Ledger  Wise Invoice";

const CustomerledgerView = () => {
    const companyDateFormat = useCompanyDateFormat();
    const { clientCompanyId, currencyId } = useParams();
    const { t, i18n } = useTranslation();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [clientCompanyName, setClientCompanyName] = useState("Customer Ledger");
    const [totalAmount, setTotalAmount] = useState("");
    const [totalPaymentAmount, setTotalPaymentAmount] = useState("");
    const [totalBalance, setTotalBalance] = useState("");
    const [currencySymbol, setCurrencySymbol] = useState("");
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    // ✅ Pagination states
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [filterPayload, setFilterPayload] = useState({
        shipmentId: '',
        fromDate: '',
        toDate: '',
    });
    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useCallback(() => {
        setFilterPayload({
            shipmentId: "",
            fromDate: "",
            toDate: "",
        });
        setPage(0);
    }, []);

    const columns = useMemo(
        () => [
            { accessorKey: 'index', header: 'SN', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'date', header: 'Date', size: 100, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'shipmentId', header: 'Shipment I’d', size: 150, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'commercialInvoiceNo', header: 'Commercial Invoice', size: 100, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: 'productName', header: 'Particular', size: 150, tableHeader: {
                    justifyContent: 'flex-start',
                }, footer: 'Total',
            },
            { accessorKey: 'invoiceAmount', header: 'Invoice Amount', size: 100, tableStyle: { textAlign: "center" }, footerCellStyle: { textAlign: "center" }, footer: `${currencySymbol} ${totalAmount ? totalAmount.toFixed(2) : '0.00'}` },
            { accessorKey: 'receiptAmount', header: 'Receipt', size: 100, footerCellStyle: { textAlign: "center" }, footer: `${currencySymbol} ${totalPaymentAmount ? totalPaymentAmount.toFixed(2) : '0.00'}` },
            { accessorKey: 'balanceAmount', header: 'Balance', size: 100, footerCellStyle: { textAlign: "center" }, footer: `${currencySymbol} ${totalBalance ? totalBalance.toFixed(2) : '0.00'}` },
        ],
        [totalAmount, totalPaymentAmount, totalBalance, currencySymbol]);


    // const fetchData = async (clientCompanyId, currencyId, pageIndex = page, pageLimit = pageSize) => {

    //     if (!pageLimit || pageLimit <= 0) pageLimit = 10;
    //     if (!pageIndex || pageIndex < 0) pageIndex = 0;
    //     setLoading(true);
    //     try {
    //         const payload = {
    //             page: pageIndex + 1,  
    //             limit: pageLimit,
    //             clientCompanyId: clientCompanyId,
    //             currencyId: currencyId,
    //             shipmentId: filterPayload.shipmentId || null,
    //             fromDate: filterPayload.fromDate || null,
    //             toDate: filterPayload.toDate || null,
    //         };
    //         const response = await genericPost(READ_CUSTOMER_LEDGER, payload, {
    //         });

    //          const { commercialInvExps, totalGrandAmount, totalGrandPayment, totalBalanceAmount } = response.data;


    //         if (commercialInvExps.length > 0) {
    //             const name = commercialInvExps[0]?.customer?.clientCompanyName || "Customer Ledger";
    //             setClientCompanyName(name);
    //         }
    //         let grandTotalAmount = 0;
    //         let grandPaymentAmount = 0;
    //         let grandBalance = 0;
    //         const mappedData = commercialInvExps.map((item, index) => {
    //             const invoiceAmount = item.particulars.reduce((sum, particular) => {
    //                 return sum + parseFloat(particular.amount || 0);
    //             }, 0);
    //             const receiptAmount = (item.receiptVouchers || []).reduce((sum, r) => {
    //                 return sum + parseFloat(r.referenceAmount || 0);
    //             }, 0);
    //             const balanceAmount = invoiceAmount - receiptAmount;
    //             const productNames = item.particulars
    //                 .slice(0, 5)
    //                 .map(p => p.products?.productName || '')
    //                 .join(', ');

    //             grandTotalAmount += invoiceAmount;
    //             grandPaymentAmount += receiptAmount;
    //             grandBalance += balanceAmount;
    //             return {
    //                 index: (index + 1).toString().padStart(2, '0'),
    //                 commercialInvExpId: item.commercialInvExpId || "",
    //                 commercialInvoiceNo: item.commercialInvoiceNo || "",
    //                 productName: productNames || "",
    //                 shipmentId: item.shipmentId || "",
    //                 date: companyDateFormat(item?.date) || '',
    //                 ciNo: item.ProformaInvExp?.proformaInvoiceNo || "",
    //                 particulars: item.particulars || [],
    //                 receiptVouchers: item.receiptVouchers || [],
    //                 invoiceAmount: `${item.currency?.currency_symbol || ''} ${invoiceAmount.toFixed(2)}`,
    //                 receiptAmount: `${item.currency?.currency_symbol || ''} ${receiptAmount.toFixed(2)}`,
    //                 balanceAmount: `${item.currency?.currency_symbol || ''} ${balanceAmount.toFixed(2)}`,
    //             };
    //         });

    //         setData(mappedData);
    //         setTotalAmount(parseFloat(totalGrandAmount || 0));
    //         setTotalPaymentAmount(parseFloat(totalGrandPayment || 0));
    //         setTotalBalance(parseFloat(totalBalanceAmount || 0));
    //         setRowCount(response.data?.pagination?.totalRecords || 0);
    //         const symbol = response.data.commercialInvExps[0]?.currency?.currency_symbol || '';
    //         setCurrencySymbol(symbol);

    //     } catch (err) {
    //         console.error("Fetch Error:", err);
    //         setError(err.message);
    //         setData([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const getRoundAmount = (amount) => {
        if (isNaN(amount)) return "0.00";
        const decimalPart = amount - Math.floor(amount);
        const rounded =
            decimalPart <= 0.50
                ? Math.floor(amount)
                : Math.ceil(amount);
        return rounded.toFixed(2);
    };




    const fetchData = async (clientCompanyId, currencyId, pageIndex = page, pageLimit = pageSize) => {

        if (!pageLimit || pageLimit <= 0) pageLimit = 10;
        if (!pageIndex || pageIndex < 0) pageIndex = 0;
        setLoading(true);

        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageLimit,
                clientCompanyId,
                currencyId,
                shipmentId: filterPayload.shipmentId || null,
                fromDate: filterPayload.fromDate || null,
                toDate: filterPayload.toDate || null,
            };

            const response = await genericPost(READ_CUSTOMER_LEDGER, payload);

            // 👉 CORRECT RESPONSE KEYS
            const {
                data: list = [],
                totalGrandAmount = 0,
                totalGrandreceipt = 0,
                totalBalanceAmount = 0,
                pagination,
            } = response.data;

            // 👉 CUSTOMER NAME
            if (list.length > 0) {
                setClientCompanyName(list[0]?.customer?.clientCompanyName || "Customer Ledger");
            }

            // 👉 Map table data correctly
            const mappedData = list.map((item, idx) => {
                const invoiceAmount = parseFloat(item.totalAmount || 0);
                const receiptAmount = parseFloat(item.totalReferenceAmount || 0);
                const balanceAmount = parseFloat(item.balanceAmount || 0);

                const productNames = (item.particulars || [])
                    .slice(0, 5)
                    .map(p => p.products?.productName || "")
                    .join(", ");

                return {
                    index: (idx + 1).toString().padStart(2, '0'),
                    commercialInvExpId: item.commercialInvExpId,
                    commercialInvoiceNo: item.commercialInvoiceNo,
                    shipmentId: item.shipmentId,
                    date: companyDateFormat(item.date),
                    productName: productNames,
                    invoiceAmount: `${item.currency?.currency_symbol || ''} ${invoiceAmount.toFixed(2)}`,
                    receiptAmount: `${item.currency?.currency_symbol || ''} ${receiptAmount.toFixed(2)}`,
                    balanceAmount: `${item.currency?.currency_symbol || ''} ${balanceAmount.toFixed(2)}`,
                };
            });

            // 👉 SET TABLE ROW DATA
            setData(mappedData);

            // 👉 SET FOOTER VALUES FROM BACKEND
            setTotalAmount(parseFloat(getRoundAmount(totalGrandAmount)));
            setTotalPaymentAmount(parseFloat(getRoundAmount(totalGrandreceipt)));
            setTotalBalance(parseFloat(getRoundAmount(totalBalanceAmount)));

            // 👉 PAGINATION ROW COUNT
            setRowCount(pagination?.totalRecords || 0);

            // 👉 Currency Symbol
            const symbol = list[0]?.currency?.currency_symbol || "";
            setCurrencySymbol(symbol);

        } catch (err) {
            console.error("Fetch Error:", err);
            setError(err.message);
            setData([]);
        } finally {
            setLoading(false);
        }
    };




    useEffect(() => {
        if (!clientCompanyId || !currencyId) return;
        fetchData(clientCompanyId, currencyId);
    }, [clientCompanyId, currencyId, token, page, pageSize, filterPayload.shipmentId, filterPayload.fromDate, filterPayload.toDate,]);

    const defaultView = 'customerledger';

    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={clientCompanyName}
                columns={columns}
                data={data}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                fromDate={filterPayload.fromDate || ""}
                toDate={filterPayload.toDate || ""}

            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        type="text"
                                        placeholder="Enter Shipment ID"
                                        value={filterPayload.shipmentId}
                                        onChange={(e) => handleFilterChange('shipmentId', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );


    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={mainContent} />
        </>
    );
};

export default CustomerledgerView;
